import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { trackVisit } from './analytics';
import Layout from './components/Layout';
import Home from './pages/Home';
import Docs from './pages/Docs';
import DocsV2 from './pages/DocsV2';
import Download from './pages/Download';
import Changelog from './pages/Changelog';
import Stats from './pages/Stats';
import ConsoleLogs from './pages/ConsoleLogs';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function PageTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    trackVisit();
  }, [pathname]);
  return null;
}

function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <PageTracker />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/docs" element={<Docs />} />
          <Route path="/docs/v2" element={<DocsV2 />} />
          <Route path="/download" element={<Download />} />
          <Route path="/changelog" element={<Changelog />} />
          <Route path="/stats" element={<Stats />} />
          <Route path="/console-logs" element={<ConsoleLogs />} />

          {/* Redirects for removed pages */}
          <Route path="/faq" element={<Navigate to="/docs" replace />} />
          <Route path="/guides/*" element={<Navigate to="/docs" replace />} />
          <Route path="/contact" element={<Navigate to="/" replace />} />

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
